import { memo, type ReactNode } from 'react';

import { type WorkspaceMemberResponseWithRoles, WorkspaceMemberType } from '@air/api/types';
import { cn } from '@air/utils-tailwind';

import { MemberRoleMenu } from '~/components/MemberRoleMenu';

type MemberListMemberRoleProps = {
  className?: string;
  member: WorkspaceMemberResponseWithRoles;
  noWorkspaceRoleLabel?: ReactNode;
};

export const MemberListMemberRole = memo(
  ({ className, member, noWorkspaceRoleLabel = 'None' }: MemberListMemberRoleProps) => {
    const isGuest = member.type === WorkspaceMemberType.guest;
    const isSysAdmin = member.type === WorkspaceMemberType.sysadmin;

    if (isGuest || isSysAdmin) {
      return (
        <div className={cn('flex-2 px-3 text-14 text-grey-8', className)} data-testid="USERS_MEMBERSHIP_ROLE">
          {noWorkspaceRoleLabel}
        </div>
      );
    }

    return (
      <div className={cn('flex-2 px-3 text-14 text-grey-12', className)} data-testid="USERS_MEMBERSHIP_ROLE">
        <div className="-ml-2">
          <MemberRoleMenu member={member} />
        </div>
      </div>
    );
  },
);

MemberListMemberRole.displayName = 'MemberListMemberRole';
